import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-staff-agenda',
  templateUrl: './staff-agenda.component.html',
  styleUrls: ['./staff-agenda.component.css']
})
export class StaffAgendaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
